<template>
  <div class="footer">
    <div class="container">
      <div class="nav nav-left">
        <span @click="openLink('/specialThanks')" class="item">Special Thanks</span>
        <span @click="openLink('https://www.youtube.com/watch?v=1vo_AVYEtG4&feature=youtu.be')" class="item">
          Watch Introduction Video
        </span>
      </div>
      <div class="nav">
        <div class="item_wrapper">
          <span @click="openLink('/termsOfService')" class="item">Terms of Service</span>
          <span @click="openLink('/privacyPolicy')" class="item">Privacy Policy</span>
          <span @click="openLink('/cookiePolicy')" class="item">Cookie Policy</span>
        </div>
        <div class="copyright">© 2026 Joyjobs. All Rights Reserved.</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const openLink = (url) => {
  window.open(url, '_blank');
};
</script>

<style lang="less" scoped>
.footer {
  background-color: white;
  padding: 10px 30px;
  position: relative;
  z-index: 10;
  .container {
    height: 50px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      float: left;
      width: 120px;
      height: auto;
    }
    .nav {
      display: flex;
      flex-wrap: wrap;
      .item_wrapper {
        width: 100%;
        text-align: right;
      }
      .item {
        color: #05644f;
        padding: 2px 2px;
        cursor: pointer;
        text-decoration: none;
        font-size: 12px;
        margin-right: 12px;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          color: #0a4ec6;
          text-decoration: underline;
          text-underline-offset: 10px;
        }
      }
      .copyright {
        width: 100%;
        color: #888888;
        text-align: right;
        padding: 2px 10px 0 0;
        font-size: 12px;
      }
    }
    .nav-left {
      flex-wrap: nowrap;
      white-space: nowrap;
    }
  }
}
@media (max-width: 1080px) {
  .footer {
    padding: 10px 10px;
    .container {
      width: 100%;
    }
  }
}
/* 真机窄屏（initial-scale=1）：右对齐的链接和版权在窄屏上折行错乱，改为竖向排布左对齐 */
@media (max-width: 640px) {
  .footer {
    padding: 12px;
    .container {
      height: auto;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      // 只给右侧链接/版权块加分割线；nav-left 也带 .nav class，必须排除，
      // 否则 "Special Thanks" 行上方会多出一条线
      .nav:not(.nav-left) {
        width: 100%;
        border-top: 1px solid #e0e0e0;
        padding-top: 8px;
        .item_wrapper {
          text-align: left;
          .item {
            white-space: nowrap; // 链接保持完整，放不下时整条换行而不是拆开
          }
        }
        .copyright {
          text-align: left;
          padding: 2px 0 0;
        }
      }
    }
  }
}
</style>
